import type { Product } from 'Services/ProductManagement/Features/Product/productSlice'
import type { FetchListParams } from 'Services/ProductManagement/types'

export enum TariffProductTabType {
  DETAILS = 'details',
  PRICING = 'pricing',
  SALES_CHANNELS = 'sales_channels',
  AVAILABILITY = 'availability'
}

export enum TariffProductsEditTabType {
  PRODUCTS = 'products'
}

export enum TariffCatalogTabType {
  PRODUCTS = 'products',
  DETAILS = 'details',
  ALLOWED_API_CLIENTS = 'allowed_api_clients'
}

export enum TariffCatalogProductTabType {
  DETAILS = 'details',
  PRICING = 'pricing',
  AVAILABILITY = 'availability'
}

export enum TariffCatalogProductsEditTabType {
  PRODUCTS = 'products'
}

export enum TariffStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  DRAFT = 'DRAFT',
  STAGED = 'STAGED',
  ACTIVE_PRE_ORDER = 'ACTIVE_PRE_ORDER'
}

export type TariffStatusType =
  | TariffStatus.ACTIVE
  | TariffStatus.PASSIVE
  | TariffStatus.DRAFT
  | TariffStatus.STAGED
  | TariffStatus.ACTIVE_PRE_ORDER

export interface TariffActivePeriod {
  days_of_week: string[]
  exceptions: string[]
  time_of_day_from: string | null
  time_of_day_until: string | null
  title: string
  valid_from: Date
  valid_now: boolean
  valid_until: Date
  zone_id: string | null
}

export interface Tariff {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  tariff_code: string
  description: string
  status: TariffStatusType
  active_period: TariffActivePeriod
  pta: string
  product_ids: string[]
  parent_product_ids: string[]
  vat_definition_id: string
  pre_order_start_timestamp: Date | null
  source: string | null
}

export interface FetchTariffListParams extends FetchListParams {}

export interface UpdateTariffRequestData extends Partial<Tariff> {
  added_products?: Product[]
}
